import { createTheme, ThemeProvider, withTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  // * override theme
  // palette: {
  //   primary: {
  //     main: Colors.primary,
  //   },
  //   secondary: {
  //     main: Colors.secondary,
  //   },
  // },
  // components: {
  //   MuiListItemButton: {
  //     styleOverrides: {
  //       root: {
  //         '&.Mui-selected': {
  //           backgroundColor: `${Colors.primary}33`,
  //         },
  //       },
  //     },
  //   },
  // },
});

interface IProps extends React.PropsWithChildren {}
const MuiThemeProvider = ({ children }: IProps) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export const muiWithTheme = withTheme;

export default MuiThemeProvider;
